import { OrdenServicio } from "./ordenServicio";

export class OrdenAbierta extends OrdenServicio {

}

export class OrdenCerrada extends OrdenServicio {

}

export class Facturacion {
    idFacturacion: number = 0;
    factura: string = '';
    ordenServicio: string = '';
    siniestro: string = '';
    tipoFactura: string = '';
    tipoServicio: string = '';
    diasCredito: number = 0;
    fechaEmision: Date = new Date();
    diasTranscurridos: number = 0;
    //fechaPago: Date = new Date();
    fechaRegistroPortal: Date = new Date();
    montoNeto: number = 0;
    subTotal: number = 0;
    iva: number = 0;
    folioFiscal: string = '';
    metodoPago: string = '';
    idPDF: number = 0;
    idXML: number = 0;
    idRegistro: number = 0;
    idOrdenServicio: number = 0;
    idEmpleado: number = 0;
    aseguradora: string = '';
    cliente: string = '';
    comentario: string = '';
    cobrado: boolean = false;
    fechaCobro: Date;
    contenidoXML: string;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/facturacion.ts